export const sendContactForm = async (
  data: {
    name: string
    email: string
    message: string
    success?: string
  },
  gReCaptchaToken: string
): Promise<{ data?: unknown; message?: string; error?: string }> => {
  const response = await fetch("/api/contact", {
    method: "POST",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...data, gRecaptchaToken: gReCaptchaToken }),
  })
  // console.log({ ...data, gRecaptchaToken: gReCaptchaToken });
  return response.json()
}
